import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as filterUtils from '../../lib/filterUtils';

class PipelineFilter extends Component {
  constructor(props) {
    super(props);

    const statuses = [
      { label: "Submissions In Process", value: "In Process",         checked: true },
      { label: "Contracts Out",          value: "Contract Out",       checked: true },
      { label: "Closing",                value: "Closing",            checked: true },
      { label: "Approvals",              value: "Approved",           checked: true },
      { label: "Declines",               value: "Declined",           checked: true },
      { label: "Offer Not Accepted",     value: "Offer Not Accepted", checked: true }
    ];

    const types = [
      { label: "New",     value: "New",     checked: true },
      { label: "Renewal", value: "Renewal", checked: true }
    ];

    this.state = {
      currentDateRange: filterUtils.initialDateRange,   // date range of current showing data
      selectedDateRange: filterUtils.initialDateRange,  // date range going to be applied for next render
      dateRangePresets: filterUtils.dateRangePresets,
      shouldSelectCustomDateRange: true,
      shouldEditCustomDateRange: false,
      statuses, types
    };

    // Bindings
    this.resetDateRange = filterUtils.resetDateRange.bind(this);
    this.resetStatuses = this.resetStatuses.bind(this);
    this.resetTypes = this.resetTypes.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.setDateRangeFromPreset = filterUtils.setDateRangeFromPreset.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.toggleType = this.toggleType.bind(this);
    this.getDateRangeSectionHTML = filterUtils.getDateRangeSectionHTML.bind(this);
    this.applyFilters = filterUtils.applyFilters.bind(this);
    this._resetFilterSectionOfCheckboxVals = filterUtils.resetFilterSectionOfCheckboxVals.bind(this);
    this._toggleFilterItemOfCheckboxVal = filterUtils.toggleFilterItemOfCheckboxVal.bind(this);

    // Refs
    this.refBtnApplyFilters = React.createRef();
  }

  resetStatuses(searchImmediately = false){
    this._resetFilterSectionOfCheckboxVals('statuses', searchImmediately);
  }

  resetTypes(searchImmediately = false){
    this._resetFilterSectionOfCheckboxVals('types', searchImmediately);
  }

  resetAll(){
    this.resetDateRange();
    this.resetStatuses();
    this.resetTypes(true);
  }

  /**
   * @param {Object} status Refer to definition of `state.statuses` for shape of status object
   */
  toggleStatus(status){
    this._toggleFilterItemOfCheckboxVal(status, 'statuses');
  }

  /**
   * @param {Object} type Refer to deinition of `state.types` for shape of type object
   */
  toggleType(type){
    this._toggleFilterItemOfCheckboxVal(type, 'types');
  }

  getAppliedFilters() {
    const statuses = this.state.statuses.filter(s => s.checked).map(s => s.value);
    const types = this.state.types.filter(t => t.checked).map(t => t.value);

    return {
      start_date: this.state.selectedDateRange.start.format(
        filterUtils.dateISOFormat
      ),
      end_date: this.state.selectedDateRange.end.format(
        filterUtils.dateISOFormat
      ),
      new_or_renewal: types.length > 0 ? types : null,
      // Use checked statuses if at least one is checked. Otherwise default to all statuses.
      stage_name: this.anyStatusesSelected(statuses)
        ? statuses
        : this.state.statuses.map((s) => s.value),
    };
  }

  anyStatusesSelected(statuses){
    return statuses.length > 0 && statuses.length < this.state.statuses.length;
  }

  render(){
    const dateRangeSectionHTML = this.getDateRangeSectionHTML();
    const FilterHeaderHTML = filterUtils.FilterHeaderHTML;
    const SectionHeader = filterUtils.SectionHeader;
    const SectionBody = filterUtils.SectionBody;
    return (
      <React.Fragment>
        <div className="filter-container">
          <FilterHeaderHTML resetAll={this.resetAll} />
          { dateRangeSectionHTML }
          <div className="section">
            <SectionHeader title="Status" />
            <SectionBody title="Status" controlType="checkbox" state={this.state.statuses} toggleFunc={this.toggleStatus} />
          </div>
          <div className="section">
            <SectionHeader title="Type" />
            <SectionBody title="Type" controlType="checkbox" state={this.state.types} toggleFunc={this.toggleType} />
          </div>
        </div>
        <a ref={this.refBtnApplyFilters} className="button is-block is-primary md-apply-filters" onClick={this.applyFilters}>Done</a>
      </React.Fragment>
    );
  }
}

PipelineFilter.propTypes = {
  applyFilters: PropTypes.func,
};

export default PipelineFilter;
